import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    IAuthenticatedUserChangePasswordPayload,
    IAuthenticatedUserChangeUserNamePayload,
} from "src/app/model/IAuthenticatedUser";
import { environment } from "src/environments/environment";
import { IRefreshToken } from 'src/app/model/IAuth';

@Injectable({
    providedIn: "root",
})
export class AuthenticatedUserService {
    constructor(private http: HttpClient) {}

    ChangePassword(
        data: IAuthenticatedUserChangePasswordPayload
    ): Observable<any> {
        return this.http.post(
            `${environment.apiURL}/user-authenticated/change-password/`,
            data
        );
    }

    ChangeUserName(
        data: IAuthenticatedUserChangeUserNamePayload
    ): Observable<any> {
        return this.http.post(
            `${environment.apiURL}/user-authenticated/change-username/`,
            data
        );
    }
    RefreshToken(data: IRefreshToken) {
        return this.http.post(`${environment.apiURL}/user/refresh-token`, data);
    }
}
